// class FundsStore {
//   constructor() {
//     /**
//      * @type {Fund[]}
//      */
//     this.funds = [];

//     this.fundFieldsFormSnapshot = [];

//     this.currentSelectedFundTab = "";

//     this.swpExpand = "";
//     this.atsExpand = "";
//   }

//   addFund(fund) {
//     this.funds.push(fund);
//   }

//   getFunds() {
//     return this.funds;
//   }

//   setFunds(funds) {
//     this.funds = funds;
//   }

//   getCurrentSelectedFundTab() {
//     return this.currentSelectedFundTab;
//   }

//   setCurrentSelectedFundTab(currentSelectedFundTab) {
//     this.currentSelectedFundTab = currentSelectedFundTab;
//   }

//   setswpExpand(swpExpandValue) {
//     this.swpExpand = swpExpandValue;
//   }
//   getswpExpand() {
//     return this.swpExpand;
//   }
//   setatsExpand(atsExpandValue) {
//     this.atsExpand = atsExpandValue;
//   }
//   getatsExpand() {
//     return this.atsExpand;
//   }

// }

import {fundsStoreInstance as FundsStore } from "shared-library";
export default  FundsStore;
